import { FC, useRef } from "react";

import { useState } from "react";
import styled from "@emotion/styled";
import OtpInput from "react18-input-otp";

import OTPCountDown from "./OTPCountDown";

import { useAppDispatch, useAppSelector } from "store";
import {
  setAuth,
  setMobile,
  setOtp,
  setProfileAndContact,
} from "store/slices/authSlice";
import { useRequestAuthOtp, useRequestKeepAlive, useSubmitAuthOtp } from "hooks/useAuth";

import useGenerateComponentKey from "hooks/useGenerateComponentKey";
import { useNavigate } from "react-router-dom";
import { Button, message, Typography } from "antd";
import { getAuthProfile } from "services/authAPI";
import { getFirebaseToken } from "services/firebase";
import { getBangbowSetting } from "services/bangbowApi";
import { saveSpeedDestinationSession } from "utils/session/speedDestinationSession";

const MobileOTPInput: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { mobile, refNo, token } = useAppSelector((state) => state.auth);

  const otpInputRef = useRef<OtpInput | null>();
  const [otp, setOTP] = useState<string>();
  const [resentOTPButtonDisabled, setResentOTPButtonDisabled] = useState(false);
  const [otpCountDownID, setOTPCountDownID] = useGenerateComponentKey();

  const { mutate: requestOtpAuth, isPending: requestOtpLoading } =
    useRequestAuthOtp();
  const { mutate: submitOtpAuth, isPending: submitOtpLoading } =
    useSubmitAuthOtp();

  const { mutate: requestKeepAlive } = useRequestKeepAlive();

  //090-xxx-x899
  const textPhoneNumber = mobile
    ? mobile.replace(/(\d{2})(\d{5})(\d{2})/, "$1x-xxx-x$3")
    : "";

  const handleRequestOtp = () => {
    requestOtpAuth(
      {
        mobile: mobile || "",
        app_name: "factory",
      },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            dispatch(setOtp({ token: data.token, refNo: data.ref_no }));
            dispatch(setMobile(mobile || ""));
            //  navigate("/confirm-otp");
            message.success("ส่ง OTP สำเร็จ");
          } else {
            message.error(`${data.error_message?.[0]}`);
          }
        },
        onError: (error) => {
          message.error(`${error}`);
        },
      }
    );
  };

  const handleGetFirebaseToken = () => {
    getFirebaseToken()
      .then((firebaseToken) => {
        console.log("Firebase token: ", firebaseToken);
        if (firebaseToken) {
          requestKeepAlive({ fcm_token: firebaseToken });
        }
      })
      .catch((err) =>
        console.error("An error occured while retrieving firebase token. ", err)
      );
  };

  const handleSendOTP = () => {
    submitOtpAuth(
      {
        app_name: "factory",
        pin: otp || "",
        ref_code: refNo || "",
        token: token || "",
      },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            console.log("dataBus", data);
            dispatch(setAuth(data));
            getAuthProfile()
              .then((res) => {
                if (res.status === "success") {
                  console.log("res", res);
                  dispatch(
                    setProfileAndContact({
                      profile: res.profile,
                      contact: res.contact,
                    })
                  );

                  // ✅ โหลด master_bangbow (north/south destination preset) แล้วเก็บลง session/local storage
                  // - ไม่ block UX: ถ้า error ให้ข้าม (ยังใช้งานระบบได้)
                  getBangbowSetting()
                    .then((settingRes) => {
                      // backend: { status, data }
                      saveSpeedDestinationSession(settingRes?.data);
                    })
                    .catch(() => undefined);


                  message.success("ยืนยัน OTP สำเร็จ");

                  navigate("/dashboard");

                  //handleGetFirebaseToken();

                  // window.location.reload();

                }
              })
              .catch((err) => {
                message.error(`${err}`);
                dispatch(setAuth({}));
              });
          } else {
            message.error(`${data.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`${error}`);
        },
      }
    );
  };

  return (
    <>
      <MainSection>
        <Typography.Title level={5}>ใส่รหัส OTP</Typography.Title>
        <Typography.Paragraph>
          เลข OTP จะถูกส่งไปที่เบอร์โทรศัพท์มือถือหมายเลข
        </Typography.Paragraph>
        <Typography.Paragraph>{textPhoneNumber}</Typography.Paragraph>
        <SectionInput>
          <OtpInput
            ref={(ref) => (otpInputRef.current = ref)}
            autoComplete="off"
            isInputNum
            isInputSecure
            shouldAutoFocus
            containerStyle={{
              width: "100%",
              overflow: "hidden",
              justifyContent: "center",
            }}
            value={otp}
            numInputs={6}
            inputStyle={{
              width: 48,
              height: 48,
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              borderBottom: "1px solid #999",
              fontSize: 24,
            }}
            focusStyle={{
              borderBottom: `1px solid #000`,
              outline: "none",
            }}
            separator={<OTPSeparator />}
            onChange={(otp: string) => setOTP(otp)}
          />
        </SectionInput>
        <SectionButton>
          <Button
            type="primary"
            loading={requestOtpLoading || submitOtpLoading}
            onClick={handleSendOTP}
            style={{ width: "100%" }}
            size="large"
            disabled={otp?.length !== 6}
          >
            ส่งรหัส
          </Button>
        </SectionButton>
        <SectionCountDown>{renderOTPResendSection()}</SectionCountDown>
      </MainSection>
    </>
  );

  function renderOTPResendSection() {
    if (!resentOTPButtonDisabled) {
      return (
        <SectionTextCountDown>
          <Typography.Paragraph>
            ส่งรหัสได้อีกครั้งใน &nbsp;{" "}
          </Typography.Paragraph>

          <OTPCountDown
            key={otpCountDownID}
            onCountDownCompleted={() => setResentOTPButtonDisabled(true)}
          />
        </SectionTextCountDown>
      );
    }

    return (
      <Button
        type="link"
        size="small"
        style={{ color: "#000000" }}
        onClick={() => {
          setOTPCountDownID();
          setResentOTPButtonDisabled(false);
          setOTP("");
          handleRequestOtp();
        }}
      >
        ส่งรหัสอีกครั้งหากไม่ได้รับ OTP ?
      </Button>
    );
  }
};

export default MobileOTPInput;

const OTPSeparator = styled.div`
  margin: 0 4px;
`;

const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const SectionButton = styled.div`
  padding: 0 20px;
  width: 390px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

const SectionCountDown = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
`;

const SectionTextCountDown = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
